// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"8Sic5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _menu = require("vanilla-starter/Menu");
var _button = require("vanilla-starter/Button");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
            children: "Menu"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                    children: "Open"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                    children: "Edit"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                    children: "Delete"
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Menu":"lHxP0","vanilla-starter/Button":"36nan","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lHxP0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuTrigger", ()=>MenuTrigger);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "MenuSection", ()=>MenuSection);
parcelHelpers.export(exports, "SubmenuTrigger", ()=>SubmenuTrigger);
parcelHelpers.export(exports, "Text", ()=>(0, _content.Text));
parcelHelpers.export(exports, "Header", ()=>(0, _menu.Header));
parcelHelpers.export(exports, "Separator", ()=>(0, _menu.Separator));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _menu.Keyboard));
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _menu = require("react-aria-components/Menu");
var _popover = require("./Popover");
var _content = require("./Content");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _menuCss = require("./Menu.css");
'use client';
function MenuTrigger(props) {
    let [trigger, menu] = (0, _reactDefault.default).Children.toArray(props.children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
        ...props,
        children: [
            trigger,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                children: menu
            })
        ]
    });
}
function Menu(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
        ...props,
        children: props.children
    });
}
function MenuItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
        ...props,
        textValue: textValue,
        children: ({ hasSubmenu, isSelected, selectionMode })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isSelected && selectionMode === 'multiple' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {}) : null,
                    isSelected && selectionMode === 'single' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Dot), {}) : null,
                    typeof props.children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        slot: "label",
                        children: props.children
                    }) : props.children,
                    hasSubmenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {})
                ]
            })
    });
}
function MenuSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuSection), {
        ...props
    });
}
function SubmenuTrigger(props) {
    let [trigger, menu] = (0, _reactDefault.default).Children.toArray(props.children);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.SubmenuTrigger), {
        ...props,
        children: [
            trigger,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                hideArrow: true,
                offset: -2,
                crossOffset: -4,
                children: menu
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","lucide-react":[["Check","9PYFQ","default"],["ChevronRight","elAlB","default"],["Dot","jsvxN","default"]],"react-aria-components/Menu":[["Header","kpwoY"],["Keyboard","eCC9q"],["Menu","8JFUP"],["MenuItem","8JFUP"],["MenuSection","8JFUP"],["MenuTrigger","8JFUP"],["SubmenuTrigger","8JFUP"],["Separator","8A8dQ"]],"./Popover":"cvyKh","./Content":"jYtLe","react":"a1TxN","./Menu.css":"4ZTwg","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9PYFQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Check);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const Check = (0, _createLucideIconJsDefault.default)("check", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAlB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jsvxN":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Dot);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12.1",
            cy: "12.1",
            r: "1",
            key: "18d7e5"
        }
    ]
];
const Dot = (0, _createLucideIconJsDefault.default)("dot", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cvyKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _popover = require("react-aria-components/Popover");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _popoverCss = require("./Popover.css");
'use client';
function Popover({ children, hideArrow, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
        ...props,
        className: (0, _clsxDefault.default)('react-aria-Popover', props.className),
        children: ({ trigger })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !hideArrow && trigger !== 'MenuTrigger' && trigger !== 'SubmenuTrigger' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            width: 12,
                            height: 12,
                            viewBox: "0 0 12 12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M0 0 L6 6 L12 0"
                            })
                        })
                    }),
                    children
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/Popover":[["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"clsx":"4P1lK","./Popover.css":"6SWas","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6SWas":[function() {},{}],"jYtLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _heading = require("react-aria-components/Heading");
var _text = require("react-aria-components/Text");
var _contentCss = require("./Content.css");
function Heading(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
        ...props
    });
}
function Text(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/Heading":"2f4nH","react-aria-components/Text":"jt9fm","./Content.css":"kvyv3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvyv3":[function() {},{}],"4ZTwg":[function() {},{}],"36nan":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("react-aria-components/Button");
var _composeRenderProps = require("react-aria-components/composeRenderProps");
var _progressCircle = require("./ProgressCircle");
var _buttonCss = require("./Button.css");
'use client';
function Button(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ...props,
        className: "react-aria-Button button-base",
        "data-variant": props.variant || 'primary',
        children: (0, _composeRenderProps.composeRenderProps)(props.children, (children, { isPending })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !isPending && children,
                    isPending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                        "aria-label": "Saving...",
                        isIndeterminate: true
                    })
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/Button":"9G5XO","react-aria-components/composeRenderProps":"bA6Cz","./ProgressCircle":"c08Ay","./Button.css":"maD70","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c08Ay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircle", ()=>ProgressCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _composeRenderProps = require("react-aria-components/composeRenderProps");
var _progressBar = require("react-aria-components/ProgressBar");
'use client';
function ProgressCircle(props) {
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let strokeWidth = 4;
    let radius = `calc(50% - ${strokeWidth / 2}px)`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBar.ProgressBar), {
        ...props,
        style: (0, _composeRenderProps.composeRenderProps)(props.style, (style)=>({
                ...style,
                width: props.size || 16,
                height: props.size || 16
            })),
        children: ({ percentage, isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    fill: "none",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 32 32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-pressed)",
                            strokeWidth: strokeWidth
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-background)",
                            strokeWidth: strokeWidth,
                            // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                            pathLength: "100",
                            // Add extra gap between dashes so 0% works in Chrome.
                            strokeDasharray: "100 200",
                            strokeDashoffset: 100 - (isIndeterminate || percentage == null ? 25 : percentage),
                            strokeLinecap: "round",
                            style: {
                                rotate: '-90deg',
                                transformOrigin: 'center center'
                            },
                            children: isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                dur: "0.75s",
                                values: "0;360",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/composeRenderProps":"bA6Cz","react-aria-components/ProgressBar":"kPGON","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"maD70":[function() {},{}],"jQ81q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _menu = require("vanilla-starter/Menu");
var _button = require("vanilla-starter/Button");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
            children: "Menu"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.Menu), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuSection), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Header), {
                            children: "Styles"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                            children: "Bold"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                            children: "Underline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuSection), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Header), {
                            children: "Align"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                            children: "Left"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                            children: "Middle"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.MenuItem), {
                            children: "Right"
                        })
                    ]
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Menu":"lHxP0","vanilla-starter/Button":"36nan","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hZXKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
    "aria-label": "Text style",
    selectionMode: "multiple",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxSection), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.Header), {
                    children: "Styles"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                    children: "Bold"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                    children: "Underline"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxSection), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.Header), {
                    children: "Align"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                    children: "Left"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                    children: "Middle"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                    children: "Right"
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kNiGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>ListBox);
parcelHelpers.export(exports, "ListBoxItem", ()=>ListBoxItem);
parcelHelpers.export(exports, "ListBoxSection", ()=>ListBoxSection);
parcelHelpers.export(exports, "ListBoxLoadMoreItem", ()=>ListBoxLoadMoreItem);
parcelHelpers.export(exports, "DropdownListBox", ()=>DropdownListBox);
parcelHelpers.export(exports, "DropdownItem", ()=>DropdownItem);
parcelHelpers.export(exports, "Text", ()=>(0, _content.Text));
parcelHelpers.export(exports, "Header", ()=>(0, _listBox.Header));
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("react-aria-components/ListBox");
var _composeRenderProps = require("react-aria-components/composeRenderProps");
var _lucideReact = require("lucide-react");
var _content = require("./Content");
var _progressCircle = require("./ProgressCircle");
var _listBoxCss = require("./ListBox.css");
'use client';
function ListBox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
        ...props,
        children: children
    });
}
function ListBoxItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
        ...props,
        textValue: textValue,
        children: (0, _composeRenderProps.composeRenderProps)(props.children, (children)=>typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "label",
                children: children
            }) : children)
    });
}
function ListBoxSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxSection), {
        ...props
    });
}
function ListBoxLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}
function DropdownListBox(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
        ...props,
        className: "dropdown-listbox"
    });
}
function DropdownItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
        ...props,
        textValue: textValue,
        className: "dropdown-item",
        children: (0, _composeRenderProps.composeRenderProps)(props.children, (children, { isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {}),
                    typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        slot: "label",
                        children: children
                    }) : children
                ]
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/ListBox":[["Header","kpwoY"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxLoadMoreItem","dNdIK"],["ListBoxSection","dNdIK"]],"react-aria-components/composeRenderProps":"bA6Cz","lucide-react":[["Check","9PYFQ","default"]],"./Content":"jYtLe","./ProgressCircle":"c08Ay","./ListBox.css":"bDSGu","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bDSGu":[function() {},{}],"g9afp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _button = require("vanilla-starter/Button");
var _react = require("react");
"use client";
function Example() {
    let [animals, setAnimals] = (0, _react.useState)([
        {
            id: 1,
            name: 'Aardvark'
        },
        {
            id: 2,
            name: 'Kangaroo'
        },
        {
            id: 3,
            name: 'Snake'
        }
    ]);
    let addItem = ()=>{
        setAnimals([
            ...animals,
            {
                id: animals.length + 1,
                name: 'Lion'
            }
        ]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
                "aria-label": "Animals",
                items: animals,
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        children: item.name
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                onPress: addItem,
                style: {
                    marginTop: 8
                },
                children: "Add item"
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","vanilla-starter/Button":"36nan","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1qLse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Example);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _toggleButtonGroup = require("vanilla-starter/ToggleButtonGroup");
var _toggleButton = require("vanilla-starter/ToggleButton");
var _react = require("react");
"use client";
const items = [
    {
        id: 1,
        name: 'Charizard',
        type: 'Fire, Flying'
    },
    {
        id: 2,
        name: 'Blastoise',
        type: 'Water'
    },
    {
        id: 3,
        name: 'Venusaur',
        type: 'Grass, Poison'
    },
    {
        id: 4,
        name: 'Pikachu',
        type: 'Electric'
    }
];
function Example() {
    let [layout, setLayout] = (0, _react.useState)('vertical');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toggleButtonGroup.ToggleButtonGroup), {
                "aria-label": "Layout",
                selectedKeys: [
                    layout
                ],
                onSelectionChange: (keys)=>setLayout([
                        ...keys
                    ][0]),
                disallowEmptySelection: true,
                style: {
                    marginBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButton.ToggleButton), {
                        id: "vertical",
                        children: "Vertical"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButton.ToggleButton), {
                        id: "horizontal",
                        children: "Horizontal"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
                items: items,
                selectionMode: "multiple",
                dependencies: [
                    layout
                ],
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MyItem, {
                        layout: layout,
                        name: item.name,
                        type: item.type
                    })
            })
        ]
    });
}
function MyItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxItem), {
        style: {
            display: 'flex',
            flexDirection: props.layout === 'horizontal' ? 'row' : 'column',
            justifyContent: 'space-between',
            alignItems: props.layout === 'horizontal' ? 'center' : 'start'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.Text), {
                slot: "label",
                children: props.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.Text), {
                slot: "description",
                children: props.type
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","vanilla-starter/ToggleButtonGroup":"iKtgt","vanilla-starter/ToggleButton":"fejmT","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iKtgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>ToggleButtonGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _toggleButtonGroup = require("react-aria-components/ToggleButtonGroup");
var _toggleButtonGroupCss = require("./ToggleButtonGroup.css");
'use client';
function ToggleButtonGroup(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonGroup.ToggleButtonGroup), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/ToggleButtonGroup":"8CiqT","./ToggleButtonGroup.css":"iSdX4","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iSdX4":[function() {},{}],"fejmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleButton", ()=>ToggleButton);
var _jsxRuntime = require("react/jsx-runtime");
var _composeRenderProps = require("react-aria-components/composeRenderProps");
var _toggleButton = require("react-aria-components/ToggleButton");
var _toggleButtonCss = require("./ToggleButton.css");
'use client';
function ToggleButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButton.ToggleButton), {
        ...props,
        className: "react-aria-ToggleButton button-base",
        "data-variant": props.variant || 'primary',
        children: (0, _composeRenderProps.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: children
            }))
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components/composeRenderProps":"bA6Cz","react-aria-components/ToggleButton":"98v4o","./ToggleButton.css":"dywkl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dywkl":[function() {},{}],"9iEsJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _collection = require("react-aria-components/Collection");
"use client";
let animals = [
    {
        id: 1,
        species: 'Aardvark'
    },
    {
        id: 2,
        species: 'Kangaroo'
    },
    {
        id: 3,
        species: 'Snake'
    }
];
let people = [
    {
        id: 4,
        name: 'David'
    },
    {
        id: 5,
        name: 'Mike'
    },
    {
        id: 6,
        name: 'Jane'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
    "aria-label": "Grouped items",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxSection), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.Header), {
                    children: "Animals"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collection.Collection), {
                    items: animals,
                    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                            id: item.species,
                            children: item.species
                        })
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxSection), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.Header), {
                    children: "People"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collection.Collection), {
                    items: people,
                    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                            id: item.name,
                            children: item.name
                        })
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","react-aria-components/Collection":"3m036","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9RyNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _collection = require("react-aria-components/Collection");
var _useAsyncList = require("react-aria-components/useAsyncList");
var _listBox = require("vanilla-starter/ListBox");
var _progressCircle = require("vanilla-starter/ProgressCircle");
"use client";
function AsyncLoadingExample() {
    let list = (0, _useAsyncList.useAsyncList)({
        async load ({ signal, cursor }) {
            let res = await fetch(cursor || `https://pokeapi.co/api/v2/pokemon`, {
                signal
            });
            let json = await res.json();
            return {
                items: json.results,
                cursor: json.next
            };
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
        "aria-label": "Pick a Pokemon",
        selectionMode: "single",
        renderEmptyState: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": "Loading..."
            }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collection.Collection), {
                items: list.items,
                children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: item.name,
                        children: item.name
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxLoadMoreItem), {
                onLoadMore: list.loadMore,
                isLoading: list.loadingState === 'loadingMore',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                    isIndeterminate: true,
                    "aria-label": "Loading more..."
                })
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(AsyncLoadingExample, {});

},{"react/jsx-runtime":"2Is6Z","react-aria-components/Collection":"3m036","react-aria-components/useAsyncList":"5dzE9","vanilla-starter/ListBox":"kNiGV","vanilla-starter/ProgressCircle":"c08Ay","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5dzE9":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable async loaded list data structure, and provides convenience methods
 * to update the data over time. Manages loading and error states, pagination, and sorting.
 */ parcelHelpers.export(exports, "useAsyncList", ()=>useAsyncList);
var _useListData = require("./useListData");
var _react = require("react");
function reducer(data, action) {
    let selectedKeys;
    switch(data.state){
        case 'idle':
        case 'error':
            switch(action.type){
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: action.abortController
                    };
                case 'update':
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                case 'success':
                case 'error':
                    return data;
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loading':
        case 'sorting':
        case 'filtering':
            switch(action.type){
                case 'success':
                    // Ignore if there is a newer abortcontroller in state.
                    // This means that multiple requests were going at once.
                    // We want to take only the latest result.
                    if (action.abortController !== data.abortController) return data;
                    selectedKeys = action.selectedKeys ?? data.selectedKeys;
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: 'idle',
                        items: [
                            ...action.items ?? []
                        ],
                        selectedKeys: selectedKeys === 'all' ? 'all' : new Set(selectedKeys),
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error,
                        abortController: undefined
                    };
                case 'loading':
                case 'loadingMore':
                case 'sorting':
                case 'filtering':
                    // We're already loading, and another load was triggered at the same time.
                    // We need to abort the previous load and start a new one.
                    data.abortController?.abort('aborting current load and starting new one');
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        case 'loadingMore':
            switch(action.type){
                case 'success':
                    selectedKeys = data.selectedKeys === 'all' || action.selectedKeys === 'all' ? 'all' : new Set([
                        ...data.selectedKeys,
                        ...action.selectedKeys ?? []
                    ]);
                    // Append the new items
                    return {
                        ...data,
                        state: 'idle',
                        items: [
                            ...data.items,
                            ...action.items ?? []
                        ],
                        selectedKeys,
                        sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                        abortController: undefined,
                        cursor: action.cursor
                    };
                case 'error':
                    if (action.abortController !== data.abortController) return data;
                    return {
                        ...data,
                        state: 'error',
                        error: action.error
                    };
                case 'loading':
                case 'sorting':
                case 'filtering':
                    // We're already loading more, and another load was triggered at the same time.
                    // We need to abort the previous load more and start a new one.
                    data.abortController?.abort();
                    return {
                        ...data,
                        filterText: action.filterText ?? data.filterText,
                        state: action.type,
                        // Reset items to an empty list if loading, but not when sorting.
                        items: action.type === 'loading' ? [] : data.items,
                        abortController: action.abortController
                    };
                case 'loadingMore':
                    // If already loading more and another loading more is triggered, abort the new load more since
                    // it is a duplicate request since the cursor hasn't been updated.
                    // Do not overwrite the data.abortController
                    action.abortController?.abort();
                    return data;
                case 'update':
                    // We're already loading, and an update happened at the same time (e.g. selectedKey changed).
                    // Update data but don't abort previous load.
                    return {
                        ...data,
                        ...action.updater?.(data)
                    };
                default:
                    throw new Error(`Invalid action "${action.type}" in state "${data.state}"`);
            }
        default:
            throw new Error(`Invalid state "${data.state}"`);
    }
}
function useAsyncList(options) {
    const { load, sort, initialSelectedKeys, initialSortDescriptor, getKey = (item)=>item.id || item.key, initialFilterText = '' } = options;
    let [data, dispatch] = (0, _react.useReducer)(reducer, {
        state: 'idle',
        error: undefined,
        items: [],
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys),
        sortDescriptor: initialSortDescriptor,
        filterText: initialFilterText
    });
    const dispatchFetch = async (action, fn)=>{
        let abortController = new AbortController();
        try {
            dispatch({
                ...action,
                abortController
            });
            let previousFilterText = action.filterText ?? data.filterText;
            let response = await fn({
                items: data.items.slice(),
                selectedKeys: data.selectedKeys,
                sortDescriptor: action.sortDescriptor ?? data.sortDescriptor,
                signal: abortController.signal,
                cursor: action.type === 'loadingMore' ? data.cursor : undefined,
                filterText: previousFilterText,
                loadingState: data.state
            });
            let filterText = response.filterText ?? previousFilterText;
            dispatch({
                type: 'success',
                ...response,
                abortController
            });
            // Fetch a new filtered list if filterText is updated via `load` response func rather than list.setFilterText
            // Only do this if not aborted (e.g. user triggers another filter action before load completes)
            if (filterText && filterText !== previousFilterText && !abortController.signal.aborted) dispatchFetch({
                type: 'filtering',
                filterText
            }, load);
        } catch (e) {
            dispatch({
                type: 'error',
                error: e,
                abortController
            });
        }
    };
    let didDispatchInitialFetch = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!didDispatchInitialFetch.current) {
            dispatchFetch({
                type: 'loading'
            }, load);
            didDispatchInitialFetch.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        items: data.items,
        selectedKeys: data.selectedKeys,
        sortDescriptor: data.sortDescriptor,
        isLoading: data.state === 'loading' || data.state === 'loadingMore' || data.state === 'sorting' || data.state === 'filtering',
        loadingState: data.state,
        error: data.error,
        filterText: data.filterText,
        getItem (key) {
            return data.items.find((item)=>getKey(item) === key);
        },
        reload () {
            dispatchFetch({
                type: 'loading'
            }, load);
        },
        loadMore () {
            // Ignore if already loading more or if performing server side filtering.
            if (data.state === 'loading' || data.state === 'loadingMore' || data.state === 'filtering' || data.cursor == null) return;
            dispatchFetch({
                type: 'loadingMore'
            }, load);
        },
        sort (sortDescriptor) {
            dispatchFetch({
                type: 'sorting',
                sortDescriptor
            }, sort || load);
        },
        ...(0, _useListData.createListActions)({
            ...options,
            getKey,
            cursor: data.cursor
        }, (fn)=>{
            dispatch({
                type: 'update',
                updater: fn
            });
        }),
        setFilterText (filterText) {
            dispatchFetch({
                type: 'filtering',
                filterText
            }, load);
        }
    };
}

},{"./useListData":"5purM","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5purM":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Manages state for an immutable list data structure, and provides convenience methods to
 * update the data over time.
 */ parcelHelpers.export(exports, "useListData", ()=>useListData);
parcelHelpers.export(exports, "createListActions", ()=>createListActions);
var _react = require("react");
function useListData(options) {
    let { initialItems = [], initialSelectedKeys, getKey = (item)=>item.id ?? item.key, filter, initialFilterText = '' } = options;
    // Store both items and filteredItems in state so we can go back to the unfiltered list
    let [state, setState] = (0, _react.useState)({
        items: initialItems,
        selectedKeys: initialSelectedKeys === 'all' ? 'all' : new Set(initialSelectedKeys || []),
        filterText: initialFilterText
    });
    let filteredItems = (0, _react.useMemo)(()=>filter ? state.items.filter((item)=>filter(item, state.filterText)) : state.items, [
        state.items,
        state.filterText,
        filter
    ]);
    return {
        ...state,
        items: filteredItems,
        ...createListActions({
            getKey
        }, setState),
        getItem (key) {
            return state.items.find((item)=>getKey(item) === key);
        }
    };
}
function createListActions(opts, dispatch) {
    let { cursor, getKey } = opts;
    return {
        setSelectedKeys (selectedKeys) {
            dispatch((state)=>({
                    ...state,
                    selectedKeys
                }));
        },
        addKeysToSelection (selectedKeys) {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return state;
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: 'all'
                };
                return {
                    ...state,
                    selectedKeys: new Set([
                        ...state.selectedKeys,
                        ...selectedKeys
                    ])
                };
            });
        },
        removeKeysFromSelection (selectedKeys) {
            dispatch((state)=>{
                if (selectedKeys === 'all') return {
                    ...state,
                    selectedKeys: new Set()
                };
                let selection = state.selectedKeys === 'all' ? new Set(state.items.map(getKey)) : new Set(state.selectedKeys);
                for (let key of selectedKeys)selection.delete(key);
                return {
                    ...state,
                    selectedKeys: selection
                };
            });
        },
        setFilterText (filterText) {
            dispatch((state)=>({
                    ...state,
                    filterText
                }));
        },
        insert (index, ...values) {
            dispatch((state)=>insert(state, index, ...values));
        },
        insertBefore (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index, ...values);
            });
        },
        insertAfter (key, ...values) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey?.(item) === key);
                if (index === -1) {
                    if (state.items.length === 0) index = 0;
                    else return state;
                }
                return insert(state, index + 1, ...values);
            });
        },
        prepend (...values) {
            dispatch((state)=>insert(state, 0, ...values));
        },
        append (...values) {
            dispatch((state)=>insert(state, state.items.length, ...values));
        },
        remove (...keys) {
            dispatch((state)=>{
                let keySet = new Set(keys);
                let items = state.items.filter((item)=>!keySet.has(getKey(item)));
                let selection = 'all';
                if (state.selectedKeys !== 'all') {
                    selection = new Set(state.selectedKeys);
                    for (let key of keys)selection.delete(key);
                }
                if (cursor == null && items.length === 0) selection = new Set();
                return {
                    ...state,
                    items,
                    selectedKeys: selection
                };
            });
        },
        removeSelectedItems () {
            dispatch((state)=>{
                if (state.selectedKeys === 'all') return {
                    ...state,
                    items: [],
                    selectedKeys: new Set()
                };
                let selectedKeys = state.selectedKeys;
                let items = state.items.filter((item)=>!selectedKeys.has(getKey(item)));
                return {
                    ...state,
                    items,
                    selectedKeys: new Set()
                };
            });
        },
        move (key, toIndex) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let copy = state.items.slice();
                let [item] = copy.splice(index, 1);
                copy.splice(toIndex, 0, item);
                return {
                    ...state,
                    items: copy
                };
            });
        },
        moveBefore (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                // Find indices of keys to move. Sort them so that the order in the list is retained.
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex);
            });
        },
        moveAfter (key, keys) {
            dispatch((state)=>{
                let toIndex = state.items.findIndex((item)=>getKey(item) === key);
                if (toIndex === -1) return state;
                let keyArray = Array.isArray(keys) ? keys : [
                    ...keys
                ];
                let indices = keyArray.map((key)=>state.items.findIndex((item)=>getKey(item) === key)).sort((a, b)=>a - b);
                return move(state, indices, toIndex + 1);
            });
        },
        update (key, newValue) {
            dispatch((state)=>{
                let index = state.items.findIndex((item)=>getKey(item) === key);
                if (index === -1) return state;
                let updatedValue;
                if (typeof newValue === 'function') updatedValue = newValue(state.items[index]);
                else updatedValue = newValue;
                return {
                    ...state,
                    items: [
                        ...state.items.slice(0, index),
                        updatedValue,
                        ...state.items.slice(index + 1)
                    ]
                };
            });
        }
    };
}
function insert(state, index, ...values) {
    return {
        ...state,
        items: [
            ...state.items.slice(0, index),
            ...values,
            ...state.items.slice(index)
        ]
    };
}
function move(state, indices, toIndex) {
    // Shift the target down by the number of items being moved from before the target
    toIndex -= indices.filter((index)=>index < toIndex).length;
    let moves = indices.map((from)=>({
            from,
            to: toIndex++
        }));
    // Shift later from indices down if they have a larger index
    for(let i = 0; i < moves.length; i++){
        let a = moves[i].from;
        for(let j = i; j < moves.length; j++){
            let b = moves[j].from;
            if (b > a) moves[j].from--;
        }
    }
    // Interleave the moves so they can be applied one by one rather than all at once
    for(let i = 0; i < moves.length; i++){
        let a = moves[i];
        for(let j = moves.length - 1; j > i; j--){
            let b = moves[j];
            if (b.from < a.to) a.to++;
            else b.from++;
        }
    }
    let copy = state.items.slice();
    for (let move of moves){
        let [item] = copy.splice(move.from, 1);
        copy.splice(move.to, 0, item);
    }
    return {
        ...state,
        items: copy
    };
}

},{"react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf16';
    else rules += ' _Le16';
    if (props.isStaticColor) rules += ' Oe16';
    else rules += ' Oh16';
    rules += ' OlOVIhfcebS7sd16';
    rules += ' OlOVIhfcebS7sd16';
    rules += ' _Mc16';
    rules += ' _Kd16';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr16';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s16';
    rules += ' oR3ltQc16';
    rules += ' nR3ltQc16';
    rules += ' kR3ltQc16';
    rules += ' jR3ltQc16';
    if (props.isStandalone) {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c16';
        rules += ' vFHT6Dd16';
    }
    if (props.isStandalone) {
        rules += ' xc16';
        rules += ' _xa16';
    }
    if (props.isStandalone) {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    }
    if (props.isStaticColor) rules += ' pl16';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po16';
        else if (props.isFocusVisible) rules += ' po16';
        else if (props.isHovered) rules += ' po16';
        else rules += ' pt16';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps16';
        else if (props.isFocusVisible) rules += ' ps16';
        else if (props.isHovered) rules += ' ps16';
        else rules += ' pu16';
    }
    rules += ' plOVIhfcA5Qiqd16';
    rules += ' plOVIhfcA5Qiqd16';
    rules += ' Yd16';
    rules += ' Xb16';
    rules += ' _2b16';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb16';
                rules += ' __Va16';
            } else if (props.isHovered) {
                rules += ' _Xb16';
                rules += ' __Va16';
            } else rules += ' _Xa16';
        }
    } else {
        rules += ' _Xb16';
        rules += ' __Va16';
    }
    rules += ' __ca16';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "L") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "S") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "XS") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a16';
        rules += ' vFHT6Dd16';
    } else {
        rules += ' -_6BNtrc-c16';
        rules += ' vFHT6Dd16';
    }
    if (props.size === "XL") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "L") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "S") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "XS") {
        rules += ' xb16';
        rules += ' _xa16';
    } else {
        rules += ' xb16';
        rules += ' _xa16';
    }
    if (props.size === "XL") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "L") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "S") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "XS") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    }
    if (props.fillStyle === "outline") rules += ' pm16';
    else if (props.fillStyle === "subtle") rules += ' pm16';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg16';
        else if (props.variant === "chartreuse") rules += ' pg16';
        else if (props.variant === "yellow") rules += ' pg16';
        else if (props.variant === "orange") rules += ' pg16';
        else if (props.variant === "notice") rules += ' pg16';
        else rules += ' px16';
    }
    rules += ' sd16';
    rules += ' ea16';
    rules += ' egLWx3bb16';
    rules += ' _oa16';
    rules += ' Sv16';
    rules += ' SgLWx3bd16';
    rules += ' Rv16';
    rules += ' RgLWx3bd16';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc16';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG16';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c16';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc16';
    } else if (!minWidth) rules += ' N4dY0ec16';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec16';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn16';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b16';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd16';
    else rules += ' -SFnbic-_Jb16';
    rules += ' -Bu7z1c-oH5kTnc16';
    rules += ' oj16';
    rules += ' nj16';
    rules += ' kj16';
    rules += ' jj16';
    rules += ' qc16';
    rules += ' qsd16';
    rules += ' -Qg41Lb-IAxCW0c16';
    rules += ' -Qg41Lb-gLWx3bIYB8I16';
    rules += ' MAyFGYc16';
    rules += ' Td16';
    rules += ' Qd16';
    rules += ' -aRvJDd-Tu7Fubd16';
    rules += ' _Ca16';
    if (props.fillStyle === "outline") rules += ' g_g16';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f16';
        else if (props.variant === "cinnamon") rules += ' gP16';
        else if (props.variant === "brown") rules += ' gO16';
        else if (props.variant === "turquoise") rules += ' gy16';
        else if (props.variant === "pink") rules += ' gT16';
        else if (props.variant === "magenta") rules += ' gS16';
        else if (props.variant === "fuchsia") rules += ' gR16';
        else if (props.variant === "purple") rules += ' gM16';
        else if (props.variant === "indigo") rules += ' gK16';
        else if (props.variant === "blue") rules += ' gG16';
        else if (props.variant === "cyan") rules += ' gC16';
        else if (props.variant === "seafoam") rules += ' gz16';
        else if (props.variant === "green") rules += ' gA16';
        else if (props.variant === "celery") rules += ' gv16';
        else if (props.variant === "chartreuse") rules += ' gJ16';
        else if (props.variant === "yellow") rules += ' gW16';
        else if (props.variant === "orange") rules += ' gV16';
        else if (props.variant === "red") rules += ' gU16';
        else if (props.variant === "gray") rules += ' gI16';
        else if (props.variant === "negative") rules += ' gU16';
        else if (props.variant === "notice") rules += ' gV16';
        else if (props.variant === "positive") rules += ' gA16';
        else if (props.variant === "neutral") rules += ' gI16';
        else if (props.variant === "informative") rules += ' gG16';
        else if (props.variant === "accent") rules += ' gG16';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm16';
        else if (props.variant === "cinnamon") rules += ' gq16';
        else if (props.variant === "brown") rules += ' gn16';
        else if (props.variant === "turquoise") rules += ' g516';
        else if (props.variant === "pink") rules += ' gx16';
        else if (props.variant === "magenta") rules += ' gD16';
        else if (props.variant === "fuchsia") rules += ' gr16';
        else if (props.variant === "purple") rules += ' go16';
        else if (props.variant === "indigo") rules += ' gl16';
        else if (props.variant === "blue") rules += ' g216';
        else if (props.variant === "cyan") rules += ' gk16';
        else if (props.variant === "seafoam") rules += ' g416';
        else if (props.variant === "green") rules += ' g116';
        else if (props.variant === "celery") rules += ' g716';
        else if (props.variant === "chartreuse") rules += ' gp16';
        else if (props.variant === "yellow") rules += ' gN16';
        else if (props.variant === "orange") rules += ' gQ16';
        else if (props.variant === "red") rules += ' gB16';
        else if (props.variant === "gray") rules += ' g616';
        else if (props.variant === "negative") rules += ' gB16';
        else if (props.variant === "notice") rules += ' gQ16';
        else if (props.variant === "positive") rules += ' g116';
        else if (props.variant === "neutral") rules += ' g616';
        else if (props.variant === "informative") rules += ' g216';
        else if (props.variant === "accent") rules += ' g216';
    }
    rules += ' _jf16';
    rules += ' _kJ8iPYd16';
    rules += ' hXMFGYc16';
    rules += ' mc16';
    rules += ' lc16';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS16';
        else if (props.variant === "notice") rules += ' i9VrKkd16';
        else if (props.variant === "positive") rules += ' ip17Jm16';
        else if (props.variant === "neutral") rules += ' i0ruhAb16';
        else if (props.variant === "informative") rules += ' iG1ze4d16';
        else if (props.variant === "accent") rules += ' iG1ze4d16';
        else rules += ' iA16';
    } else rules += ' iA16';
    rules += ' -_8sjo0b-t5ZbAob16';
    if (props.size === "XL") rules += ' -M_-MBaYFfc16';
    else if (props.size === "L") rules += ' -M_-M3JjxG16';
    else if (props.size === "S") rules += ' -M_-MCe2o8c16';
    else if (props.size === "XS") rules += ' -M_-MifsFYc16';
    else rules += ' -M_-M4dY0ec16';
    rules += ' -_k_-_kc16';
    rules += ' -h_-hc16';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG16';
                        rules += ' QAzEcG16';
                        rules += ' _Jb16';
                        rules += ' _Nc16';
                        rules += ' Pc16';
                        rules += ' _Yb16';
                        if (props.overflowMode === "wrap") rules += ' _7b16';
                        else if (props.overflowMode === "truncate") rules += ' _7c16';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja16"
                    }),
                    styles: " ZuUmpre16 FuUmpre16 I67logd16 _va16"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"jAv02":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 14.384c0 .653.615 1.121 1.251.973 2.435-.566 4.249-2.75 4.249-5.357s-1.814-4.79-4.249-5.357c-.636-.148-1.251.32-1.251.973z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rFkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M10 6.35c2.012 0 3.65 1.638 3.65 3.65s-1.638 3.65-3.65 3.65S6.35 12.012 6.35 10 7.988 6.35 10 6.35m0-1.5c-2.84 0-5.15 2.31-5.15 5.15s2.31 5.15 5.15 5.15 5.15-2.31 5.15-5.15S12.84 4.85 10 4.85M10 3.25c-.414 0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75V2.5c0 .414-.336.75-.75.75M10 19.5c-.414 0-.75-.336-.75-.75V17.5c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .414-.336.75-.75.75M2.5 10.75H1.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H2.5c.414 0 .75.336.75.75s-.336.75-.75.75M18.75 10.75H17.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M15.304 5.446c-.193 0-.384-.073-.53-.22-.294-.292-.294-.767 0-1.06l.883-.884c.293-.293.768-.293 1.06 0s.294.768 0 1.06l-.883.885c-.146.146-.338.22-.53.22M3.813 16.938c-.193 0-.384-.074-.53-.22-.294-.293-.294-.768 0-1.06l.883-.885c.293-.293.768-.293 1.06 0s.294.768 0 1.061l-.883.884c-.147.146-.338.22-.53.22M4.696 5.446c-.192 0-.383-.073-.53-.22l-.884-.883c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l.885.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22M16.188 16.938c-.193 0-.384-.074-.53-.22l-.885-.884c-.293-.293-.293-.768 0-1.06s.768-.294 1.061 0l.884.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=collections.8674c0cb.js.map
